import { createSlice } from "@reduxjs/toolkit";
import { createUnavailability } from "./api";
import { FULFILLED, PENDING, REJECTED } from "../../constants";

interface UnavailabilityState {
  unAvailability: string | null;
  requestStatus: string;
}

const initialState: UnavailabilityState = {
  unAvailability: null,
  requestStatus: FULFILLED,
};

export const UnavailabilitySlice = createSlice({
  name: "unavailability",
  initialState,
  reducers: {},
  extraReducers: {
    [createUnavailability.pending.type]: (state) => {
      state.requestStatus = PENDING;
      state.unAvailability = null;
    },

    [createUnavailability.fulfilled.type]: (state, { payload }) => {
      state.requestStatus = FULFILLED;
      state.unAvailability = payload?.message || null;
    },

    [createUnavailability.rejected.type]: (state,{payload}) => {
      state.requestStatus = REJECTED;
      state.unAvailability = payload?.message;
    },
  },
});

export const {} = UnavailabilitySlice.actions;
export default UnavailabilitySlice.reducer;
